var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_571_4939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.9998,
    height: 27.9998,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_571_4939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8138 1.558C11.8678 1.81427 11.0457 2.38429 10.538 3.13574C10.2189 3.60798 0.425807 21.7739 0.261574 22.1981C-0.593968 24.4081 0.733026 26.959 3.04828 27.5547C3.46605 27.6622 3.63563 27.6639 13.8078 27.6639C23.9538 27.6639 24.1507 27.662 24.5705 27.5555C25.7641 27.2527 26.7472 26.4501 27.269 25.3525C27.7291 24.3844 27.791 23.2317 27.4355 22.2525C27.2851 21.8381 17.4153 3.54989 17.0998 3.10083C16.6289 2.43073 15.8991 1.89275 15.1052 1.63039C14.5025 1.43122 13.4091 1.39669 12.8138 1.558ZM14.4949 8.23548C14.81 8.37569 15.1639 8.73034 15.3134 9.05573C15.4287 9.30656 15.4296 9.33773 15.4296 13.0068V16.7051L15.2835 16.9837C14.9915 17.5406 14.4486 17.8744 13.8348 17.8744C13.2211 17.8744 12.6782 17.5406 12.3862 16.9837L12.2401 16.7051V13.003V9.30091L12.4032 8.97997C12.5897 8.61319 12.9612 8.29318 13.3483 8.16587C13.6637 8.06221 14.1753 8.09326 14.4949 8.23548ZM14.2122 19.564C15.1706 19.7204 15.937 20.4277 16.1846 21.3842C16.3372 21.9736 16.2565 22.6109 15.9599 23.1593C15.7569 23.5345 15.2561 23.9925 14.8235 24.1987C14.4762 24.3642 14.4231 24.3735 13.832 24.3735C13.2203 24.3735 13.1993 24.3694 12.8008 24.1713C10.505 23.0298 11.2051 19.7017 13.7808 19.5127C13.8254 19.5095 14.0195 19.5325 14.2122 19.564Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.c30377490249524f663cf7e4895f3374.svg";
export { ForwardRef as ReactComponent };